export let AlignmentTypeEnum = Object.freeze({
  LEFT: "Left",
  CENTER: "Center",
  RIGHT: "Right"
});
